// api/productApi.ts

import { baseApi } from './baseApi';
// @ts-ignore
const blogApi = baseApi.injectEndpoints({
  endpoints: (build) => ({
    post: build.mutation({
      query: (data) => ({
        url: '/blog/create/',
        method: 'POST',
        data,
        credentials: 'include',
      }),
      invalidatesTags: ['blog'],
    }),
    update: build.mutation({
      query: ({ id, data }: { id: string; data: any }) => ({
        url: `/blog/update/${id}`,
        method: 'PATCH',
        data,
        credentials: 'include',
      }),
      invalidatesTags: ['blog'],
    }),
    get: build.query({
      query: (queryParameters) => ({
        url: '/blog/',
        method: 'GET',
        params: queryParameters,
      }),
    }),
    getSingleData: build.query({
      query: (id: string) => ({
        url: `/blog/${id}`,
        method: 'GET',
      }),
      providesTags: ['blog'],
    }),
    getByAuthor: build.query({
      query: (id) => ({
        url: `/blog/admin/author/${id}`,
        method: 'GET',
      }),
    }),
    delete: build.mutation({
      query: (productId) => ({
        url: `/blog/delete/${productId}`,
        method: 'DELETE',
        credentials: 'include',
      }),
      invalidatesTags: ['blog'],
    }),
    postBlogTag: build.mutation({
      query: (data) => ({
        url: '/others/add-blog-tag/',
        method: 'POST',
        data,
        credentials: 'include',
      }),
      invalidatesTags: ['blog'],
    }),
    getBlogTag: build.query({
      query: () => ({
        url: '/others/get-all-blog-tags/',
        method: 'GET',
      }),
    }),
    deleteBlogTag: build.mutation({
      query: (tagId) => ({
        url: `/others/delete-blog-tag/${tagId}`,
        method: 'DELETE',
        credentials: 'include',
      }),
      invalidatesTags: ['blog'],
    }),

    // header tag api
    postHeaderTag: build.mutation({
      query: (data) => ({
        url: '/others/add-header-tag/',
        method: 'POST',
        data,
        credentials: 'include',
      }),
      invalidatesTags: ['blog'],
    }),
    getHeaderTag: build.query({
      query: () => ({
        url: '/others/get-all-header-tags/',
        method: 'GET',
      }),
    }),
    deleteHeaderTag: build.mutation({
      query: (tagId) => ({
        url: `/others/delete-header-tag/${tagId}`,
        method: 'DELETE',
        credentials: 'include',
      }),
      invalidatesTags: ['blog'],
    }),
  }),
});

export const {
  useDeleteMutation,
  useGetQuery,
  useGetSingleDataQuery,
  usePostMutation,
  useUpdateMutation,
  usePostBlogTagMutation,
  useGetBlogTagQuery,
  useDeleteBlogTagMutation,
  usePostHeaderTagMutation,
  useGetHeaderTagQuery,
  useDeleteHeaderTagMutation,
  useGetByAuthorQuery,
} = blogApi;
